import React from "react";
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import "./SessionPageV2.css";
import PosCustomDropdown from "../../../../customComponents/PosCustomDropdown/PosCustomDropdown";
import LocationModalV2 from "../all-products/components/LocationModal/indexV2";
import SessionPageLeft from "./SessionPageLeft";

const SessionPageV2 = () => {
  return (
    <Navbar>
      <Box sx={{ width: "100%", backgroundColor: "var(--surface-white)" }}>
        <Grid container sx={{ height: "100%" }}>
          <Grid item xs={12} md={6}>
            <SessionPageLeft/>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="sessionPageRightContainer">
              <div>
                <p className="sessionPageHeadingText">Start Session</p>
                <LocationModalV2/>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Navbar>
  );
};

export default SessionPageV2;
